export default {
  methods: {
    errorMessage (error) {
      let message = 'O servidor remoto parece estar indisponível! Por favor, tente novamente mais tarde.'

      if (error.response !== undefined && error.response.data !== undefined && error.response.data.code !== undefined) {
        switch (error.response.data.code) {
          case 'EMAIL_EMPTY_OR_INVALID':
            message = 'O e-mail inserido é inválido! Por favor, verifique se está escrito corretamente.'
            break

          case 'PIN_EMPTY_OR_INVALID':
            message = 'O PIN inserido é inválido! Por favor, verifique se você digitou corretamente.'
            break

          case 'IMPOSSIBLE_TO_CHECK_PIN':
            message = 'Não foi possível checar o PIN armazenado em nuvem! Por favor, avise a equipe de suporte.'
            break

          case 'INCORRECT_PIN':
            message = 'O PIN inserido não foi encontrado! Por favor, verifique se inseriu corretamente ou clique em CANCELAR e refaça o processo.'
            break

          case 'EXPIRED_PIN':
            message = 'O PIN inserido está expirado! Por favor, clique em CANCELAR e refaça o processo para obter um PIN válido.'
            break

          case 'IMPOSSIBLE_TO_GET_USER':
            message = 'Não foi possível obter os dados armazenados em nuvem do usuário! Por favor, avise a equipe de suporte.'
            break

          case 'IMPOSSIBLE_TO_SAVE_USER':
            message = 'Não foi possível armazenar os dados em nuvem! Por favor, avise a equipe de suporte.'
            break

          case 'SMTP_SERVER_UNREACHABLE':
            message = 'O servidor de envio de e-mails está indisponível! Por favor, tente novamente mais tarde.'
            break

          case 'IMPOSSIBLE_TO_SAVE_PIN':
            message = 'Não foi possível armazenar os dados em nuvem! Por favor, avise a equipe de suporte.'
            break

          case 'ERROR_TO_SEND_MAIL':
            message = 'Não foi possível enviar o e-mail com o PIN! Por favor, tente novamente mais tarde.'
            break

          case 'IMPOSSIBLE_TO_DELETE_SIMULATIONS':
            message = 'Não foi possível apagar as suas simulações! Por favor, avise a equipe de suporte.'
            break

          case 'IMPOSSIBLE_TO_DELETE_FARMS':
            message = 'Não foi possível apagar as fazendas vinculadas à sua conta! Por favor, avise a equipe de suporte.'
            break

          case 'IMPOSSIBLE_TO_DELETE_USER':
            message = 'Não foi possível apagar a sua conta de usuário! Por favor, avise a equipe de suporte.'
            break

          case 'NAME_NOT_SEND':
            message = 'Houve um erro no envio do nome!'
            break

          case 'IMPOSSIBLE_TO_CHANGE_NAME':
            message = 'Não foi possível alterar o seu nome de usuário! Por favor, avise a equipe de suporte.'
            break

          case 'NOT_DELETE_EMBRAPA':
            message = 'Usuários com e-mail da Embrapa não podem ser deletados por esta via. Contacte o suporte para dar prosseguimento.'
            break

          case 'IS_NOT_EMBRAPIAN':
            message = 'Somente empregados da Embrapa podem executar esta ação!'
            break

          case 'IS_NOT_MAINTAINER':
            message = 'É necessário ser mantenedor deste projeto para efetuar esta ação!'
            break

          case 'IS_NOT_MANAGER':
            message = 'Este portal é exclusivo para membros da equipe de gestão do Embrapa I/O!'
            break

          case 'VERY_LONG_DOMAIN':
            message = 'Os domínios das URLs não podem conter mais de 64 caracteres! [' + error.response.data.info + ']'
            break

            // Autenticação por biometria (Passkey)

          case 'NO_PASSKEYS_REGISTERED':
            message = 'Nenhuma biometria está cadastrada para este e-mail. Entre com o PIN e cadastre a biometria no menu do seu usuário.'
            break

          case 'PASSKEY_NOT_FOUND':
            message = 'Esta biometria não está mais cadastrada na sua conta. Entre com o PIN e registre a biometria novamente.'
            break

          case 'CHALLENGE_EXPIRED':
            message = 'O tempo para confirmar a biometria expirou. Por favor, tente novamente.'
            break

          case 'INVALID_CHALLENGE':
            message = 'Esta solicitação de biometria não é mais válida. Por favor, tente novamente.'
            break

          case 'VERIFICATION_FAILED':
            message = 'Não foi possível validar a sua biometria. Por favor, tente novamente.'
            break

          case 'CREDENTIAL_ID_REQUIRED':
            message = 'O navegador não enviou os dados da biometria. Por favor, tente novamente.'
            break

          case 'USER_NOT_FOUND':
            message = 'Usuário não encontrado!'
            break

          case 'REGISTRATION_OPTIONS_ERROR':
          case 'REGISTRATION_VERIFY_ERROR':
            message = 'Não foi possível registrar a biometria! Por favor, tente novamente mais tarde.'
            break

          case 'AUTH_OPTIONS_ERROR':
          case 'AUTH_VERIFY_ERROR':
            message = 'Não foi possível entrar com a biometria! Por favor, tente novamente mais tarde ou utilize o PIN.'
            break

          case 'LIST_PASSKEYS_ERROR':
            message = 'Não foi possível consultar as biometrias cadastradas! Por favor, tente novamente mais tarde.'
            break

          case 'REMOVE_PASSKEY_ERROR':
          case 'REMOVE_ALL_PASSKEYS_ERROR':
            message = 'Não foi possível remover a biometria! Por favor, tente novamente mais tarde.'
            break

          default:
            message += ' [' + error.response.data.code + (error.response.data.info ? ': ' + JSON.stringify(error.response.data.info) : '') + ']'
        }
      } else {
        console.log(error)
      }

      return message
    }
  }
}
